import { useState } from 'react'
import InputFormCard from '@component/InputFormCard'
import UnitAdornment from '@component/UnitAdornment'
import { TextField } from '@mui/material'
import { useHistoryList } from '@component/HistoryList'
import { useTranslation } from 'react-i18next'
import { Query } from '@core/query'
import { Controller } from 'react-hook-form'
import { useWindTunnelStudy } from './context'
import { makeFormRules } from '@/utils'

function WindTunnelStudyForm () {
  const { t } = useTranslation()
  const { form, setResult } = useWindTunnelStudy()
  const { appendHistory } = useHistoryList()

  const {
    control,
    reset,
    handleSubmit,
  } = form

  const rules = makeFormRules()

  const [isLoading, setLoading] = useState(false)
  const onSubmit = handleSubmit(async _ => {
    if (_.height <= 0 || _.outerArea <= 0) {
      alert(t('SENTENCE.CHECK_YOUR_INPUT'))
      return
    }

    setLoading(true)
    const res = await Query.requestCalcWindTunnelStudy(_)
    setLoading(false)

    setResult(res)
    appendHistory({
      type: 'WindTunnelStudy',
      ..._,
      result: res,
    })
  })

  const onReset = () => {
    reset()
    setResult(null)
  }

  return (
    <InputFormCard
      title={t('GLOSSARY.WIND_TUNNEL_STUDY')}
      onReset={onReset}
      onSubmit={onSubmit}
      loading={isLoading}
    >
      <Controller
        control={control}
        name="outerArea"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.OUTER_AREA')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m2" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
    </InputFormCard>
  )
}

export default WindTunnelStudyForm
